const { countryCodeToName } = require('core');

module.exports = function getParty(party) {
    const result = {
    	name: '&nbsp;',
    	street: '&nbsp;',
    	postalString: '&nbsp;',
    	country: '&nbsp;'
    };
    if(!party || !party.Name)
        return result;

    result.name = party.Name;
    result.street = party.Address;
    result.country = countryCodeToName[party.CountryCode] || '&nbsp;';

    var postalString = `${party.PostalCode || ''} ${party.City || ''}`;
    postalString = postalString.trim();
    if(postalString)
    	result.postalString = postalString;

    return result;
};

function negotiateCountryCodeAndPostalCode(countryCode, postalCode) {
	if(countryCode && postalCode)
		return `${countryCode}-${postalCode}`;
	else if(countryCode)
		return countryCode;
	else if(postalCode)
		return postalCode;
	return '';
}